export default "__VITE_ASSET__e94ba16b__"